import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpClient,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from "rxjs"
import { StorageService } from '../services/storage.service';
import { catchError, filter, take, switchMap, map } from "rxjs/operators";
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptorInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor( 
    private storageService: StorageService, 
    private http: HttpClient, 
    private authService: AuthService,
    private router: Router
    ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = JSON.parse(localStorage.getItem('usuario')) ? JSON.parse(localStorage.getItem('usuario')).token : '';
    let authReq : HttpRequest<any> = req.clone();
    // const authReq = req.clone({headers: req.headers.set('x-isapre', `${environment.ISAPRE}`)});

    if (token) {
      req = this.addToken(req, token);
    }
    return next.handle(authReq)
        .pipe(
            catchError(err => {
                if (err instanceof HttpErrorResponse && err.status === 401 && err.headers.has('Token-Expired') ) {
                  let request = {
                    token
                  };
                  return this.handle401Error(req, next, token);
                }
                else if( err.status === 401 && !err.headers.has('Token-Expired')){
                  this.router.navigate(["/auth"]);
                  return throwError("No autorizado");
                } else{
                  return throwError(err);
                }
            })
        );
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler, oldToken: string) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      let body = {
        token: oldToken
      };
      return this.authService.refreshToken(body).pipe(
        switchMap((result: any) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(result.token);
          return next.handle(this.addToken(request, result.token));
        }));
  
    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(jwt => {
          return next.handle(this.addToken(request, jwt));
        }));
    }
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`
      }
    });
  }
  
}
